import {
    request2,
    request1
} from './request';

// 列表
export function getList(obj) {
    return request2({
        url: "/api2/TZsbAdminOrderApi/PayConfigAdmin/GetPageList",
        method: "get",
        params: {
            Payment: obj.payment,
            Name: obj.name,
            // PageIndex: obj.pageIndex,
            // PageSize: obj.pageSize,
        }
    })
}

// 查看详情
export function getDetail(id) {
    return request2({
        url: "/api2/TZsbAdminOrderApi/PayConfigAdmin/GetDetails",
        method: "get",
        params: {
            id: id
        }
    })
}
// 添加
export function Create(obj) {
    return request2({
        url: "/api2/TZsbAdminOrderApi/PayConfigAdmin/Create",
        method: "post",
        data: {
            Payment: obj.payment,
            Name: obj.name,
            AppId: obj.appId,
            AppSecret: obj.appSecret,
            MCHID: obj.mchId,
            KEY: obj.key,
            // GatewayUrl: obj.gatewayUrl,
            // SignType: obj.signType,
            // Charset: obj.charset,
            PublicKey: obj.publicKey,
            PrivateKey: obj.privateKey,
            PublicKeyTwo: obj.publicKeyTwo
        }
    })
}

// 编辑
export function Edit(obj) {
    return request2({
        url: "/api2/TZsbAdminOrderApi/PayConfigAdmin/Edit",
        method: "post",
        data: {
            Id: obj.id,
            Payment: obj.payment,
            Name: obj.name,
            AppId: obj.appId,
            AppSecret: obj.appSecret,
            MCHID: obj.mchId,
            KEY: obj.key,
            // GatewayUrl: obj.gatewayUrl,
            // SignType: obj.signType,
            // Charset: obj.charset,
            PublicKey: obj.publicKey,
            PrivateKey: obj.privateKey,
            PublicKeyTwo: obj.publicKeyTwo
        }
    })
}

// 删除配置
export function Delete(id) {
    return request2({
        url: "/api2/TZsbAdminOrderApi/PayConfigAdmin/Delete",
        method: "post",
        params: {
            id: id
        }
    })
}

// 启用/禁用配置
export function IsOpenOrClose(obj) {
    return request2({
        url: "/api2/TZsbAdminOrderApi/PayConfigAdmin/CloseConfig",
        method: "post",
        data: {
            id: obj.id,
            IsOpen: obj.isOpen,
        }
    })
}

// 切换账号
export function switchPaymentAccount(id) {
    return request2({
        url: "/api2/TZsbAdminOrderApi/PayConfigAdmin/SwitchPayment",
        method: "get",
        params: {
            id: id
        }
    })
}

// 获取相关枚举列表
export function getSearchHead() {
    return request2({
        url: "/api2/TZsbAdminOrderApi/PayConfigAdmin/PayConfigSearchHead",
        method: "get",
    })
}

// 微信支付配置列表
export function getWechatPayList(obj) {
    return request2({
        url: '/api2/TZsbAdminOrderApi/WeChatPayConfigAdmin/GetList',
        method: 'get',
        params:{
            name:obj.name,
            payment:obj.payment,
            id:obj.id,
        }
    });
}
// 支付宝支付配置列表
export function getAliPayList(obj) {
    return request2({
        url: '/api2/TZsbAdminOrderApi/AliPayConfigAdmin/GetList',
        method: 'get',
        params:{
            name:obj.name,
            id:obj.id,
        }
    });
}
// 添加微信支付配置
export function CreateWechat(obj) {
    return request2({
        url: "/api2/TZsbAdminOrderApi/WeChatPayConfigAdmin/Create",
        method: "post",
        data: {
            // Payment: obj.payment,
            // Name: obj.name,
            // AppId: obj.appId,
            // AppSecret: obj.appSecret,
            MCHID: obj.mchId,
            KEY: obj.key,
            // AppletsAppId:obj.appletsAppId,
            // AppletsAppSecret:obj.appletsAppSecret,
            Remarks:obj.remarks,
            CompanyId:obj.companyId,
            CollectionCode:obj.collectionCode,
        }
    })
}
// 添加支付宝支付配置
export function CreateAli(obj) {
    return request2({
        url: "/api2/TZsbAdminOrderApi/AliPayConfigAdmin/Create",
        method: "post",
        data: {
            // Name: obj.name,
            CompanyId:obj.companyId,
            CollectionCode:obj.collectionCode,
            AppId: obj.appId,
            SignType: obj.signType,
            Charset: obj.charset,
            PublicKey: obj.publicKey,
            PrivateKey: obj.privateKey,
            PublicKeyTwo: obj.publicKeyTwo,
            Remarks:obj.remarks,
        }
    })
}
// 编辑微信支付配置
export function EditWechat(obj) {
    return request2({
        url: "/api2/TZsbAdminOrderApi/WeChatPayConfigAdmin/Edit",
        method: "post",
        data: {
            Id: obj.id,
            // Name: obj.name,
            // AppSecret: obj.appSecret,
            MCHID: obj.mchId,
            KEY: obj.key,
            // AppletsAppId:obj.appletsAppId,
            // AppletsAppSecret:obj.appletsAppSecret,
            CompanyId:obj.companyId,
            CollectionCode:obj.collectionCode,
            Remarks:obj.remarks,
        }
    })
}
// 编辑支付宝支付配置
export function EditAli(obj) {
    return request2({
        url: "/api2/TZsbAdminOrderApi/AliPayConfigAdmin/Edit",
        method: "post",
        data: {
            Id: obj.id,
            // Name: obj.name,
            CompanyId:obj.companyId,
            CollectionCode:obj.collectionCode,
            AppId: obj.appId,
            // GatewayUrl: obj.gatewayUrl,
            SignType: obj.signType,
            Charset: obj.charset,
            PublicKey: obj.publicKey,
            PrivateKey: obj.privateKey,
            PublicKeyTwo: obj.publicKeyTwo,
            Remarks:obj.remarks,
        }
    })
}
// 查看微信支付配置详情
export function getDetailWechat(id) {
    return request2({
        url: "/api2/TZsbAdminOrderApi/WeChatPayConfigAdmin/GetDetails",
        method: "get",
        params: {
            id: id
        }
    })
}
// 查看支付宝支付配置详情
export function getDetailAli(id) {
    return request2({
        url: "/api2/TZsbAdminOrderApi/AliPayConfigAdmin/GetDetails",
        method: "get",
        params: {
            id: id
        }
    })
}
// 删除微信支付配置
export function DeleteWechat(id) {
    return request2({
        url: "/api2/TZsbAdminOrderApi/WeChatPayConfigAdmin/Delete",
        method: "post",
        params: {
            id: id
        }
    })
}
// 删除支付宝支付配置
export function DeleteAli(id) {
    return request2({
        url: "/api2/TZsbAdminOrderApi/AliPayConfigAdmin/Delete",
        method: "post",
        params: {
            id: id
        }
    })
}
// 启用/禁用微信支付配置
export function IsOpenOrCloseWeChat(obj) {
    return request2({
        url: "/api2/TZsbAdminOrderApi/WeChatPayConfigAdmin/CloseConfig",
        method: "post",
        data: {
            id: obj.id,
            IsOpen: obj.isOpen,
        }
    })
}
// 切换账号微信支付配置
export function switchPaymentAccountWeChat(id) {
    return request2({
        url: "/api2/TZsbAdminOrderApi/WeChatPayConfigAdmin/SwitchPayment",
        method: "get",
        params: {
            id: id
        }
    })
}
// 启用/禁用支付宝支付配置
export function IsOpenOrCloseAli(obj) {
    return request2({
        url: "/api2/TZsbAdminOrderApi/AliPayConfigAdmin/CloseConfig",
        method: "post",
        data: {
            id: obj.id,
            IsOpen: obj.isOpen,
        }
    })
}
// 切换账号支付宝支付配置
export function switchPaymentAccountAli(id) {
    return request2({
        url: "/api2/TZsbAdminOrderApi/AliPayConfigAdmin/SwitchPayment",
        method: "get",
        params: {
            id: id
        }
    })
}
// 获取关联公司主体选项列表
export function getCompanyComList(obj){
    return request2({
        url: "/api7/SBCenterAdminApi/Company/GetCompanyList",
        method: "post",
        data: {
            id: obj.id,
            pageSize:obj.pageSize
        }
    })
}
// 设置默认系统收款账号
export function SetSystemDefaultAccountWx(id){
    return request2({
        url: "/api2/TZsbAdminOrderApi/WeChatPayConfigAdmin/SetSystemDefaultAccount?id="+id,
        method: "post",
    })
}
// zfb设置默认系统收款账号
export function SetSystemDefaultAccountZfb(id){
    return request2({
        url: "/api2/TZsbAdminOrderApi/AliPayConfigAdmin/SetSystemDefaultAccount?id="+id,
        method: "post",
    })
}

// 订单列表 /TZsbWebOrderApi/Order/GetOrderList
export function getOrderList(obj){
    return request1({
        url: "/api2/TZsbWebOrderApi/Order/GetOrderList",
        method: "post",
        data: obj
    })
}

// 生产二维码 ​/TZsbWebOrderApi​/Order​/GenerateQrCode
export function GenerateQrCode(obj){
    return request1({
        url: "/api2/TZsbWebOrderApi/Order/GenerateQrCode",
        method: "get",
        params: obj
    })
}